<template>
  <div class="phone-code-wrapper">
    <button type="button" @click="toggleList" class="phoneCodes_btn">
      <div class="phoneCodes_btn__flag"
           :style="{backgroundImage: `url(/flat/64/${activePhoneCode.cc}.png)`}"></div>
    </button>
    <div id="phoneCodes"
         v-show="phoneCodesVisible"
         @mouseleave="phoneCodesVisible = false">
      <label class="search-cont">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.97083 0.716675C7.12083 0.716675 4.80416 3.06667 4.80416 5.93334C4.80416 7.15001 5.22083 8.25001 5.90416 9.15001L1.00416 14.1C0.720831 14.4 0.720831 14.8667 1.00416 15.15C1.15416 15.3 1.3375 15.3667 1.52083 15.3667C1.72083 15.3667 1.90416 15.3 2.05416 15.15L6.95417 10.1833C7.80417 10.8 8.8375 11.15 9.95417 11.15C12.8042 11.15 15.1208 8.80001 15.1208 5.93334C15.1375 3.05001 12.8208 0.716675 9.97083 0.716675ZM9.97083 9.83334C7.85416 9.83334 6.1375 8.08334 6.1375 5.93334C6.1375 3.78334 7.85416 2.03335 9.97083 2.03335C12.0875 2.03335 13.8042 3.78334 13.8042 5.93334C13.8042 8.08334 12.0875 9.83334 9.97083 9.83334ZM12.5542 6.00001C12.5208 6.28334 12.2708 6.50001 11.9875 6.50001C11.9542 6.50001 11.9375 6.50001 11.9042 6.50001C11.5875 6.45001 11.3708 6.16667 11.4042 5.85001C11.5208 4.98334 10.5542 4.53334 10.5042 4.51667C10.2208 4.38334 10.0875 4.03334 10.2208 3.75001C10.3542 3.46668 10.6875 3.33335 10.9875 3.45001C11.0542 3.46668 12.7875 4.26668 12.5542 6.00001ZM11.3375 7.26667C11.4542 7.38334 11.5375 7.56668 11.5375 7.73335C11.5375 7.91668 11.4708 8.08335 11.3375 8.20001C11.2208 8.31668 11.0375 8.40001 10.8708 8.40001C10.7042 8.40001 10.5208 8.33335 10.4042 8.20001C10.2875 8.08335 10.2042 7.90001 10.2042 7.73335C10.2042 7.56668 10.2708 7.38334 10.4042 7.26667C10.5208 7.15001 10.7042 7.06668 10.8708 7.06668C11.0375 7.06668 11.2042 7.13334 11.3375 7.26667Z" fill="#29ABE2"/>
        </svg>
        <input class="search-input" type="text" v-model="search">
      </label>
      <ul v-if="findToggle">
        <li v-for="code in searchResult"
            :key="code.id"
            @click="getPhoneCode(code, $event)"
            :class="{'active': code.id == activeId}">
          <img :src="`/flat/64/${code.cc}.png`" alt="">
          <span>{{maskName(code)}} ({{code.code}})</span>
        </li>
      </ul>
      <ul v-if="!findToggle" class="no-search">
        <li>
          {{$t('forms.notFound')}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapState,mapMutations} from 'vuex'

  export default {
    name: 'phoneCodeComponent',
    props: {
      activeDefault: {
        type: String,
        required: false
      }
    },
    filters: {
      toNumbers(val) {
        for (let i = 1; i < val.length; i++) {
          if (i > 9) {
            val = val.replace('#', i - 9)
          } else {
            val = val.replace('#', i);
          }

        };
        return val
      }
    },
    data() {
      return {
        phoneCodesVisible: false,
        search: '',
        activeId: this.$store.state.activePhoneCode.id
      }
    },
    computed: {
      ...mapState({
        phoneCodes: state => state.phoneCodes,
        activePhoneCode: state => state.activePhoneCode,
      }),
      searchResult() {
        return this.phoneCodes.filter((country) => {
          let search = this.search.toLowerCase();
          return country.name_ru.toLowerCase().includes(search) ||
                 country.name_en.toLowerCase().includes(search) ;
        })
      },
      findToggle() {
        return !this.searchResult.length == 0;
      }
    },
    methods: {
      ...mapMutations({
        setActive: 'SET_ACTIVE_PHONE_CODE'
      }),
      maskName(mask) {
        let locale = this.$i18n.locale;
        let lang = `name_${locale}`;
        return mask[lang];
      },
      toggleList() {
        this.phoneCodesVisible = !this.phoneCodesVisible;
        this.search = '';
      },
      getPhoneCode(val, event) {
        this.setActive(val);
        this.activeId = this.activePhoneCode.id;
        this.search = '';
        // if (event) {
        //   setTimeout(() => event.target.parentElement.parentElement.parentElement.parentElement.nextElementSibling.value = val.code, 1);
        // }
        setTimeout(() => {
          this.phoneCodesVisible = false;
        }, 10)
      }
    },
    mounted() {
      if (this.activeDefault) {

        let index = this.activeDefault.indexOf(' ');
        let code = this.activeDefault.slice(0,index);
        for (let i = 0; i < this.phoneCodes.length; i++) {
          let item = this.phoneCodes[i];

          if (item.code == code) {
            this.setActive(item);
            break;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .no-search li {
    padding: 0 10px;
  }

  .phone-code-wrapper {
    z-index: 2;
    position: absolute;
    left: 5px;
    bottom: 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media screen and (max-width: 1000px) {
      top: 41px;
    }
  }

  .phoneCodes_btn {
    width: 45px;
    height: 30px;
    position: relative;
    cursor: pointer;
    &:before {
      content: '';
      width: 5px;
      height: 5px;
      position: absolute;
      border-bottom: 1px solid $darkBlue;
      border-right: 1px solid  $darkBlue;
      transform: rotate(45deg) translate(-50%, 0);
      right: 0;
      top: 50%;
    }
  }
  .phoneCodes_btn__flag {
    width: 30px;
    height: 30px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
    background-size: 38px 56px;
    background-position: center;
  }
  #phoneCodes {
    top: 100%;
    left: 0;
    width: 170px;
    max-height: 182px;
   // box-shadow: 0px 6px 12px rgba(3, 154, 114, 0.24);
    margin-top: 10px;
    background: #fff;
    position: absolute;

    ul {
      max-height: 140px;
      overflow-y: auto;
      overflow-x: hidden;
      @include scrollbal(2px);
      border: 1px solid $lightBlue;
      border-radius: 4px;

      li {
        display: flex;
        cursor: pointer;
        border-bottom: 1px solid #d0ecea;
        &:last-child {
          border-bottom: 0;
        }
        &.active {
          background: $lightGrey;
          span {
            color: $lightBlue;
          }
        }
        &:hover {
          span {
            color: $lightBlue;
          }
        }
        img {
          width: 24px;
          height: 28px;
          margin-left: 7px;
          margin-right: 13px;
          margin-top: 4px;
        }
        span {
          font-size: 14px;
          line-height: 18px;
          padding-top: 8px;
          padding-bottom: 8px;
          color: $darkBlue;
          word-wrap: break-word;
          width: 113px;
        }
      }
    }
    .search-cont {
      width: 100%;

      svg {
        position: absolute;
        margin: 10px;
      }
      .search-input {
        margin: 0;
        width: 100%;
        height: 100%;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: .25px;
        color: $darkBlue!important;
        padding: 0 10px 0 30px!important;
        height: 36px;
      }
    }
  }
</style>
